module.exports = __webpack_public_path__ + "img/404.bea3c210.png";